function readPathDetail() {
  return {
    urlHash: window.location.hash,
    urlPath: window.location.pathname
  };
}
export {
  readPathDetail
};
//# sourceMappingURL=readPathDetail.js.map
